






























import {Component, Vue} from "vue-property-decorator";
import myTitle from "./components/myTitle.vue";

@Component({
  components: {
    myTitle
  },
})

export default class ITservice extends Vue{
  path = 'assets/solution/ITservice/';

  cardContent = [
    {src:this.path+'shebei.png',title:'设备维修难度大',text:'IT设备维修难度大，对工程师的能力要求高，非行业的专业工程师难以胜任',offset:2},
    {src:this.path+'tuandui.png',title:'服务团队效率低',text:'服务商接单慢、效率低，IT设备的问题会影响整个企业的正常运行，不能及时接单导致企业损失巨大',offset:1},
    {src:this.path+'baoxiu.png',title:'报修渠道太单一',text:'传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差',offset:1},
    {src:this.path+'beijian.png',title:'备件管理不科学',text:'没有制定科学的备件管理计划，导致需要维修时备件缺货，临时调度成本高且影响设备维修进度',offset:2},
    {src:this.path+'jixiao.png',title:'绩效考核不到位',text:'企业对服务人员的满意度无法清晰反馈，服务商不能做针对性改进，用户体验难以提高',offset:1},
    {src:this.path+'jindu.png',title:'服务进度不明确',text:'服务状况难以跟进，服务商没有成熟的管理系统，不清楚售后服务是否按企业要求的标准进行，容易与客户产生争议，影响企业口碑',offset:1},
  ];
  solutions = [
    {
      img: this.path+'first.png',
      title:'专业认证的服务人员',
      text:'拥有专业的自有团队，近百名具有CCIE、HCIE、H3CTE等证书的专家工程师，通过ISO20000服务认证，获得ITSS信息技术服务运行维护标准，在IT网络行业的专业性毋庸置疑'
    },
    {
      img: this.path+'second.png',
      title:'多渠道快速售后处理',
      text:'平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，系统统一处理工单，服务人员将第一时间接单，快速响应，及时处理'
    },
    {
      img: this.path+'third.png',
      title:'科学化备件管理',
      text:'平台提供备件管理功能，让用户准确跟踪每一个备件的动向，通过对备件使用情况的多维度分析，制定出科学的备件管理计划'
    },
    {
      img: this.path+'fourth.png',
      title:'完善的绩效考核机制',
      text:'用户可对服务人员的满意度进行评价，评价结果将会对服务人员的绩效产生影响，用量化满意度的方式促进平台进步，从而更好地满足用户需求'
    },
  ];
}
